<template>
  <div>
    <v-snackbar
      v-model="infoAction.snackbar"
      :color="infoAction.color"
      top="top"
    >
      {{ infoAction.message }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="infoAction.snackbar = false">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <div>
      <center class="mt-3">
        <v-card
          color="#ffeeee"
          class="pa-1 rounded-pill"
          :width="$vuetify.breakpoint.xs ? '250px' : '632px'"
        >
          <div class="d-flex">
            <v-btn
              elevation="0"
              class="rounded-pill"
              :text="statusTab != 0"
              @click="
                $route.query.batch ? $router.push('/pencairan_saldo') : null,
                  (statusTab = 0),
                  getBatch()
              "
              style="color: #c90000"
              :width="$vuetify.breakpoint.xs ? '120px' : '200px'"
              small
              ><b>Menunggu</b></v-btn
            >
            <v-btn
              elevation="0"
              :text="statusTab != 1"
              @click="
                $route.query.batch ? $router.push('/pencairan_saldo') : null,
                  (statusTab = 1),
                  getBatch()
              "
              class="rounded-pill mx-3"
              style="color: #c90000"
              :width="$vuetify.breakpoint.xs ? '120px' : '200px'"
              small
              ><b>Diproses</b></v-btn
            >
            <v-btn
              elevation="0"
              :text="statusTab != 6"
              @click="
                $route.query.batch ? $router.push('/pencairan_saldo') : null,
                  (statusTab = 6),
                  getBatch()
              "
              class="rounded-pill"
              style="color: #c90000"
              :width="$vuetify.breakpoint.xs ? '120px' : '200px'"
              small
              ><b>Selesai</b></v-btn
            >
          </div>
        </v-card>
      </center>
    </div>
    <br />
    <v-card
      v-if="listBatch.length == 0"
      height="80vh"
      class="pa-4 d-flex align-center justify-center"
    >
      <div>
        <center>
          <img width="500px" src="/img/nodatapencairan.png" />
        </center>
        <h2>Belum ada pengajuan pencairan</h2>
      </div>
    </v-card>
    <v-row v-else dense>
      <v-col cols="12" sm="2">
        <!-- menunggu pencairan -->
        <v-card elevation="1" class="px-2 pt-3" height="80vh" outlined>
          <center style="color:#c90000"><h4>Pilih Tanggal Batch</h4></center>
          <div style="overflow-y:scroll;height:74vh" class="pr-2">
            <v-card
              v-for="(item, index) in listBatch"
              :key="index"
              outlined
              @click="
                $route.query.batch ? $router.push('/pencairan_saldo') : null,
                  (pickBatch = item.tanggal),
                  getBatchUser()
              "
              :color="pickBatch == item.tanggal ? '#ffeeee' : ''"
              :style="
                pickBatch == item.tanggal ? 'border:2px solid #c90000' : ''
              "
              class="px-2 py-1 my-1"
            >
              <!-- <div style="text-align:right">
                <v-chip style="font-size:12px" label small
                  >Medium Priority</v-chip
                >
              </div> -->
              <center class="mt-1">
                <div style="font-size:12px">
                  {{ item.tanggal | dateFormat }}
                </div>
              </center>
            </v-card>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <!-- proses -->
        <v-card elevation="1" class="px-2 pt-3" height="80vh" outlined>
          <center style="color:#c90000"><h4>Daftar Pengguna</h4></center>
          <div class="d-flex align-center mx-2">
            <v-text-field
              outlined
              v-model="searchUser"
              @keyup.enter="
                $route.query.batch ? $router.push('/pencairan_saldo') : null,
                  getBatchUser()
              "
              label="Cari"
              prepend-inner-icon="mdi-magnify"
              hide-details
              dense
            ></v-text-field>
            <v-btn elevation="0" color="#c90000" class="ml-2"
              ><v-icon color="#fff">mdi-tray-arrow-down</v-icon></v-btn
            >
          </div>
          <div style="overflow-y:scroll;height:67vh" class="px-2 mt-2">
            <div v-if="listBatchUser.length == 0" style="margin-top:100px">
              <center>
                <img width="100px" src="/img/nodatapencairan.png" />
                <h4>User tidak ditemukan</h4>
              </center>
            </div>
            <div v-else>
              <v-card
                v-for="item in listBatchUser"
                :key="item.id"
                outlined
                :color="
                  pickBatchUser.id_pencairan == item.id_pencairan
                    ? '#ffeeee'
                    : ''
                "
                :style="
                  pickBatchUser.id_pencairan == item.id_pencairan
                    ? 'border:2px solid #c90000'
                    : ''
                "
                @click="
                  $route.query.batch ? $router.push('/pencairan_saldo') : null,
                    (pickBatchUser = item)
                "
                class="pa-2 my-1"
              >
                <div style="position:relative">
                  <div>
                    <h4>{{ item.nama }}</h4>
                    <div style="font-size:14px;color:#989B9E">
                      No. Referensi {{ item.no_referensi }} <br />
                      {{ item.total_saldo }} Pencarian Transaksi
                    </div>
                    <div
                      :style="
                        item.rekening.length == 0
                          ? 'font-size:14px;color:#BD251C'
                          : 'font-size:14px;color:#c90000'
                      "
                    >
                      <span v-if="item.rekening.length == 0"
                        >Rekening Belum Diatur Default</span
                      >
                      <span v-else>
                        {{ item.rekening[0].nama_rekening }} <br />
                        {{
                          item.rekening[0].code_bank +
                            ' - ' +
                            item.rekening[0].nomor_rekening
                        }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="item.count_ditolak > 0"
                    @click="dialogDetailAlasanTolak = true"
                    style="position:absolute;right:0;top:0"
                  >
                    <v-icon color="#E9554B">mdi-alert</v-icon>
                  </div>
                  <div
                    v-if="statusTab == 1 || statusTab == 6"
                    style="position:absolute;right:0;bottom:0"
                  >
                    <h5 style="color:#BD251C" v-if="statusTab == 1">
                      Diproses
                    </h5>
                    <h5 style="color:#E0AA06" v-if="statusTab == 6">Selesai</h5>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card v-if="pickBatchUser == null" height="80vh">
          <div style="padding-top:130px">
            <center>
              <img width="100px" src="/img/nodatapencairan.png" />
              <h4>Transaksi tidak ditemukan</h4>
            </center>
          </div>
        </v-card>
        <v-card
          v-else
          elevation="1"
          :height="statusTab == 0 ? '63vh' : statusTab == 1 ? '35vh' : '63vh'"
        >
          <div
            class="px-2 pb-2"
            :style="
              statusTab == 0
                ? 'overflow-y:scroll;height:62vh'
                : statusTab == 1
                ? 'overflow-y:scroll;height:34vh'
                : 'overflow-y:scroll;height:62vh'
            "
          >
            <!-- card atas -->
            <v-expansion-panels focusable :value="0">
              <!-- detail transaksi -->
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-spacer></v-spacer>
                  <h4 style="color:#c90000">Detail Transaksi Saldo</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <div
                    style="overflow-y:scroll;height:35vh"
                    class="pr-1 pl-0 mt-2 pb-2"
                  >
                    <template>
                      <v-expansion-panels>
                        <v-expansion-panel
                          v-for="item in pickBatchUser.detail_saldo"
                          :key="item.id"
                        >
                          <v-expansion-panel-header class="py-2 px-2">
                            <div class="d-flex align-center mr-1">
                              <div style="width:100%">
                                <div class="d-flex justify-space-between">
                                  <div>Nomor Pesanan</div>
                                  <div>{{ item.no_order }}</div>
                                </div>
                                <div class="mt-1 d-flex justify-space-between">
                                  <div>Status</div>
                                  <div
                                    :style="
                                      statusTab == 0
                                        ? 'color:#c90000;text-align:right'
                                        : statusTab == 1
                                        ? 'color:#BD251C;text-align:right'
                                        : 'color:#E0AA06;text-align:right'
                                    "
                                  >
                                    {{
                                      statusTab == 0
                                        ? 'Menunggu Pencairan'
                                        : statusTab == 1
                                        ? 'Diproses'
                                        : 'Selesai'
                                    }}
                                  </div>
                                </div>
                                <div class="mt-1 d-flex justify-space-between">
                                  <div>Total Pembayaran</div>
                                  <div>
                                    <h4 style="text-align:right">
                                      Rp
                                      {{
                                        Number(
                                          item.jumlah ? item.jumlah : 0
                                        ).toLocaleString('id-ID')
                                      }}
                                    </h4>
                                    <div
                                      style="color:#BD251C;font-size:12px;text-align:right"
                                      v-if="item.biaya_transaksi"
                                    >
                                      (inc. Admin Rp
                                      {{
                                        Number(
                                          item.biaya_transaksi
                                            ? item.biaya_transaksi
                                            : 0
                                        ).toLocaleString('id-ID')
                                      }})
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="pa-0">
                            <v-list v-if="item.iklan">
                              <v-list-item>
                                <v-list-item-avatar tile size="50">
                                  <v-img
                                    :src="$url_img + item.iklan.photo"
                                  ></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title>
                                    <h5>{{ item.iklan.judul }}</h5>
                                    <div style="font-size: 14px" class="my-1">
                                      Jumlah :
                                      {{
                                        item.jumlah_unit ? item.jumlah_unit : 0
                                      }}
                                    </div>
                                    <h5 style="color: #c90000">
                                      Rp.
                                      {{
                                        Number(
                                          item.jumlah ? item.jumlah : 0
                                        ).toLocaleString('id-ID')
                                      }}
                                    </h5>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </template>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- detail user -->
              <v-expansion-panel v-if="dataUser" class="mt-2 pa-0"
                ><v-expansion-panel-header class="py-2 px-2 pa-0">
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-img
                          :src="
                            dataUser.photo
                              ? $url_img + dataUser.photo
                              : '/img/profile.png'
                          "
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          dataUser.nama
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          dataUser.nomor_hp
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-header>
                <v-expansion-panel-content style="font-size:14px">
                  <div class="d-flex align-center justify-space-between">
                    <div>No. Telepon</div>
                    <div>{{ dataUser.nomor_hp ? dataUser.nomor_hp : '-' }}</div>
                  </div>
                  <div class="d-flex align-center justify-space-between">
                    <div>No. Whatsapp</div>
                    <div>
                      {{
                        dataUser.nomor_whatsapp ? dataUser.nomor_whatsapp : '-'
                      }}
                    </div>
                  </div>
                  <div class="d-flex align-center justify-space-between">
                    <div>Nama</div>
                    <div>{{ dataUser.nama ? dataUser.nama : '-' }}</div>
                  </div>
                  <div class="d-flex align-center justify-space-between">
                    <div>Nomor KTP</div>
                    <div>
                      {{ dataUser.nomor_ktp ? dataUser.nomor_ktp : '-' }}
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <!-- rekening user -->
            <v-card
              v-if="
                (statusTab == 0 || statusTab == 6) &&
                  pickBatchUser != null &&
                  pickBatchUser.rekening.length != 0
              "
              elevation="1"
              class="px-2 mt-2 pt-3"
              height="12vh"
              outlined
            >
              <div
                v-if="pickBatchUser.rekening.length != 0"
                class="d-flex justify-space-between align-center"
              >
                <div>Nomor Rekening</div>
                <div class="d-flex align-center">
                  <img
                    width="50px"
                    height="40px"
                    :src="$url_img + pickBatchUser.rekening[0].foto"
                  />
                  <div>
                    {{ pickBatchUser.rekening[0].nomor_rekening }}
                  </div>
                  <v-icon
                    @click="
                      clipBoardCopy(pickBatchUser.rekening[0].nomor_rekening)
                    "
                    small
                    >mdi-content-copy</v-icon
                  >
                </div>
              </div>
              <div
                v-if="pickBatchUser.rekening.length != 0"
                class="d-flex justify-space-between align-center"
              >
                <div>Nama Rekening</div>
                <div>{{ pickBatchUser.rekening[0].nama_rekening }}</div>
              </div>
            </v-card>
          </div>
        </v-card>
        <!-- upload bukti pembayaran -->
        <v-card
          v-if="statusTab == 1 && pickBatchUser != null"
          elevation="1"
          class="px-2 mt-2 pt-3"
          height="27vh"
          outlined
        >
          <center>
            <h4 style="color:#c90000">Upload Bukti Pembayaran</h4>
            <v-divider class="mx-3 mt-2"></v-divider>
          </center>
          <div v-if="pickBatchUser.rekening.length != 0">
            <div class="d-flex justify-space-between align-center">
              <div>Nomor Rekening</div>
              <div class="d-flex align-center">
                <img
                  width="50px"
                  height="40px"
                  :src="$url_img + pickBatchUser.rekening[0].foto"
                />
                <div>
                  {{ pickBatchUser.rekening[0].nomor_rekening }}
                </div>
                <v-icon
                  @click="
                    clipBoardCopy(pickBatchUser.rekening[0].nomor_rekening)
                  "
                  small
                  >mdi-content-copy</v-icon
                >
              </div>
            </div>
            <div class="d-flex justify-space-between align-center">
              <div>Nama Rekening</div>
              <div>{{ pickBatchUser.rekening[0].nama_rekening }}</div>
            </div>
          </div>
          <div class="pa-2">
            <v-file-input
              class="d-none"
              @change="onFileChange"
              id="inputGambar"
              v-model="buktiBayar.bukti"
            ></v-file-input>

            <div
              v-if="!buktiBayar.bukti"
              @click="document.getElementById('inputGambar').click()"
              class="py-3"
              style="cursor:pointer;border-radius:10px;background:#ffeeee;border:2px dashed #c90000"
            >
              <center>
                <div class="d-flex justify-center align-center">
                  <v-icon class="mr-2" large color="#c90000"
                    >mdi-cloud-upload-outline</v-icon
                  >
                  <h5 style="font-size:14px;color:#c90000">
                    Unggah bukti pembayaran disini
                  </h5>
                </div>
              </center>
            </div>
            <div v-else class="py-2 d-flex align-center justify-space-between">
              <div
                style="width:100%"
                class="mr-3 d-flex align-center justify-space-between"
              >
                <v-avatar tile>
                  <v-img
                    :src="buktiBayar.gambarBuktiPembayaran"
                    contain
                    :width="50"
                    :height="50"
                  >
                  </v-img>
                </v-avatar>
                <div style="width:100%" class="px-2">
                  <div>
                    {{
                      buktiBayar.namaBuktiPembayaran.length > 15
                        ? buktiBayar.namaBuktiPembayaran.substring(0, 15) +
                          '....'
                        : buktiBayar.namaBuktiPembayaran
                    }}
                  </div>
                  <v-progress-linear
                    color="#c90000"
                    :value="loadValue"
                  ></v-progress-linear>
                  <b style="font-size:12px;color:#c90000">
                    <center>{{ loadValue }}%</center>
                  </b>
                </div>
                <div>
                  <v-icon
                    @click="clearBukti()"
                    v-if="loadValue < 100"
                    color="red"
                    >mdi-close</v-icon
                  >
                  <v-icon v-else color="#c90000">mdi-check</v-icon>
                </div>
              </div>
              <div
                v-if="loadValue == 100 && buktiBayar.bukti"
                class="py-3"
                style="border-radius:10px;background:#ffeeee;border:2px dashed #c90000"
              >
                <div class="px-3 d-flex justify-center align-center">
                  <v-btn
                    @click="document.getElementById('inputGambar').click()"
                    small
                    block
                    outlined
                    :style="{
                      background: 'linear-gradient(to right, #c90000, #f9c72a)',
                      color: 'white'
                    }"
                    >Ubah</v-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </v-card>
        <!-- button proses -->
        <v-card
          v-if="pickBatchUser != null && (statusTab == 0 || statusTab == 1)"
          elevation="1"
          class="px-2 mt-2 pt-3"
          height="16vh"
          outlined
        >
          <div style="text-align:right">
            {{ pickBatchUser.detail_saldo.length }} Transaksi
          </div>
          <div style="color:#c90000" class="d-flex justify-space-between">
            <h4>Total Pembayaran</h4>
            <h4>
              Rp
              {{
                Number(
                  pickBatchUser.total_saldo ? pickBatchUser.total_saldo : 0
                ).toLocaleString('id-ID')
              }}
            </h4>
          </div>
          <div v-if="statusTab == 0">
            <v-btn
              :disabled="pickBatchUser.rekening.length == 0 ? true : false"
              @click="isiDialogKonfirmasi('proses')"
              width="100%"
              class="mt-1 white--text"
              :style="{
                background: 'linear-gradient(to right, #c90000, #f9c72a)',
                color: 'white'
              }"
              >Proses</v-btn
            >
          </div>
          <div v-if="statusTab == 1" class="d-flex align-center justify-center">
            <v-btn
              :disabled="pickBatchUser.rekening.length == 0 ? true : false"
              outlined
              @click="dialogAlasanTolak = true"
              width="40%"
              class="mt-1 mr-1"
              :style="{
                background: 'linear-gradient(to right, #af0000, #c90000)',
                color: 'white'
              }"
              >Batal Proses</v-btn
            >
            <v-btn
              :disabled="
                pickBatchUser.rekening.length != 0 &&
                loadValue == 100 &&
                buktiBayar.bukti
                  ? false
                  : true
              "
              class="ml-1 mt-1 white--text"
              width="40%"
              @click="isiDialogKonfirmasi('konfirmasi')"
              :style="{
                background: 'linear-gradient(to right, #c90000, #f9c72a)',
                color: 'white'
              }"
              >Konfirmasi</v-btn
            >
          </div>
        </v-card>
        <!-- bukti pembayaran -->
        <v-card
          v-if="pickBatchUser != null && statusTab == 6"
          elevation="1"
          class="px-2 mt-2 pt-3"
          height="16vh"
          outlined
        >
          <center>
            <h4 style="color:#c90000">Bukti Pembayaran</h4>
            <v-divider class="mx-3 mt-2"></v-divider>
          </center>
          <div class="mt-2 d-flex justify-space-between align-center">
            <div>
              <viewer>
                <img
                  id="buktiBayarSaldo"
                  width="50px"
                  height="40px"
                  :src="$url_img + pickBatchUser.bukti_pencairan"
                  alt=""
                />
              </viewer>
            </div>
            <v-btn
              :style="{
                background: 'linear-gradient(to right, #c90000, #f9c72a)',
                color: 'white'
              }"
              class="white--text"
              @click="document.getElementById('buktiBayarSaldo').click()"
              >lihat bukti</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogAlasanTolak" max-width="400px" persistent>
      <v-card class="pa-3">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">
            Alasan Batalkan Proses
          </h4>
          <v-icon @click="(dialogAlasanTolak = false), (alasanTolak = '')"
            >mdi-close</v-icon
          >
        </div>
        <br />
        <v-textarea
          v-model="alasanTolak"
          outlined
          label="Alasan Tolak"
          hide-details
          dense
        >
        </v-textarea>
        <v-card-actions class="pr-0">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="alasanTolak ? false : true"
            color="#c90000"
            @click="postBatalProses()"
            class="white--text"
            >Ya, Tolak</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetailAlasanTolak" max-width="500px" persistent>
      <v-card class="pa-3">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">
            Riwayat Pembatalan Proses Refund Saldo
          </h4>
          <v-icon @click="dialogDetailAlasanTolak = false">mdi-close</v-icon>
        </div>
        <br />
        <div
          v-if="pickBatchUser != null"
          style="height:300px;overflow-y:scroll"
          class="pr-2"
        >
          <template v-if="pickBatchUser.count_ditolak > 0">
            <v-timeline dense align-top>
              <v-timeline-item
                v-for="(item, index) in pickBatchUser.detail_ditolak"
                :key="index"
                color="none"
                small
              >
                <template v-slot:icon>
                  <span>{{ pickBatchUser.count_ditolak - index }}</span>
                </template>
                <div>
                  <div class="d-flex align-center">
                    <h4>
                      {{ item.nama }}
                    </h4>
                    <span class="ml-2">membatalkan proses</span>
                  </div>
                  <v-card color="#EBF0F4" class="pa-2">
                    {{ item.alasan }}
                  </v-card>
                  <div style="font-size:14px;margin-top:5px">
                    {{ item.created_at | dateTimeFormat }}
                  </div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </template>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogKonfirmasi" width="400px">
      <v-card class="pa-6">
        <center>
          <img :src="dataDialogKonfirmasi.image" alt="" />
          <h5 style="color:#c90000">
            {{ dataDialogKonfirmasi.text }}
          </h5>
        </center>
        <div class="mt-2 d-flex justify-center align-center">
          <v-btn
            class="mr-2"
            outlined
            color="#c90000"
            @click="dialogKonfirmasi = false"
            >Batal</v-btn
          >
          <v-btn
            v-if="dataDialogKonfirmasi.action == 'proses'"
            color="#c90000"
            class="ml-2 white--text"
            @click="postProsesPencairan()"
            >Ya, Proses</v-btn
          >
          <v-btn
            v-if="dataDialogKonfirmasi.action == 'konfirmasi'"
            color="#c90000"
            class="ml-2 white--text"
            @click="postPencairanSaldo()"
            >Ya, Konfirmasi</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import imageCompression from 'browser-image-compression';
import Viewer from 'v-viewer';
import Vue from 'vue';
import moment from 'moment';
Vue.use(Viewer);
export default {
  data() {
    return {
      dialogKonfirmasi: false,
      dataDialogKonfirmasi: {
        image: '/img/nodata.png',
        text: '',
        action: ''
      },
      panelData: [0],
      document,
      statusTab: 0,
      batch: [
        {
          id: 0,
          tgl: '31 Desember 2023',
          status: 'Hight Priority',
          id_status: 1
        },
        {
          id: 1,
          tgl: '31 Desember 2023',
          status: 'Hight Priority',
          id_status: 1
        },
        {
          id: 2,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 3,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 4,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 0,
          tgl: '31 Desember 2023',
          status: 'Hight Priority',
          id_status: 1
        },
        {
          id: 1,
          tgl: '31 Desember 2023',
          status: 'Hight Priority',
          id_status: 1
        },
        {
          id: 2,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 3,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 4,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 0,
          tgl: '31 Desember 2023',
          status: 'Hight Priority',
          id_status: 1
        },
        {
          id: 1,
          tgl: '31 Desember 2023',
          status: 'Hight Priority',
          id_status: 1
        },
        {
          id: 2,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 3,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        },
        {
          id: 4,
          tgl: '31 Desember 2023',
          status: 'Medium Priority',
          id_status: 2
        }
      ],
      dataUser: [
        {
          id: 0,
          nama: 'Bapuk',
          no_referensi: 11223344,
          total: 100,
          idBank: 0
        },
        {
          id: 0,
          nama: 'Bapuk',
          no_referensi: 11223344,
          total: 100,
          idBank: 0
        },
        {
          id: 1,
          nama: 'Rohman',
          no_referensi: 11223344,
          total: 90,
          idBank: 1
        },
        {
          id: 2,
          nama: 'Zaenal',
          no_referensi: 11223344,
          total: 400,
          idBank: 0
        },
        {
          id: 3,
          nama: 'Alpha',
          no_referensi: 11223344,
          total: 20,
          idBank: 1
        },
        {
          id: 4,
          nama: 'Bapuk',
          no_referensi: 11223344,
          total: 80,
          idBank: 1
        },
        {
          id: 0,
          nama: 'Bapuk',
          no_referensi: 11223344,
          total: 100,
          idBank: 0
        }
      ],
      dataTransaksi: [
        {
          id: 0,
          no_pesanan: '7788883399',
          id_status: 0,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        },
        {
          id: 1,
          no_pesanan: '7788883399',
          id_status: 0,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        },
        {
          id: 2,
          no_pesanan: '7788883399',
          id_status: 1,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        },
        {
          id: 3,
          no_pesanan: '7788883399',
          id_status: 1,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        },
        {
          id: 4,
          no_pesanan: '7788883399',
          id_status: 1,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        },
        {
          id: 4,
          no_pesanan: '7788883399',
          id_status: 1,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        },
        {
          id: 4,
          no_pesanan: '7788883399',
          id_status: 1,
          status: 'Menunggu pencarian',
          total: 10000,
          admin: 2000
        }
      ],
      users: [],
      listBatch: [],
      pickBatch: '',
      listBatchUser: [],
      pickBatchUser: null,
      dialogAlasanTolak: false,
      buktiBayar: {
        bukti: null,
        gambarBuktiPembayaran: null,
        namaBuktiPembayaran: '',
        buktiCompressed: null
      },
      loadValue: 0,
      searchUser: '',
      alasanTolak: '',
      dialogDetailAlasanTolak: false,
      infoAction: {
        snackbar: false,
        message: '',
        color: ''
      },
      dataUser: null
    };
  },
  // watch: {
  //   statusTab: function(val) {
  //     this.getBatch();
  //   }
  // },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  },
  methods: {
    clipBoardCopy(val) {
      navigator.clipboard.writeText(val);
      this.infoAction = {
        snackbar: true,
        message: 'Berhasil disalin',
        color: 'success'
      };
    },
    isiDialogKonfirmasi(item) {
      if (item == 'proses') {
        this.dataDialogKonfirmasi = {
          image: '/img/nodata.png',
          text: 'Apakah anda yakin untuk memproses pencairan berikut?',
          action: 'proses'
        };
      }
      if (item == 'konfirmasi') {
        this.dataDialogKonfirmasi = {
          image: '/img/nodata.png',
          text: 'Apakah anda yakin ingin konfirmasi pembayaran pencairan?',
          action: 'konfirmasi'
        };
      }
      this.dialogKonfirmasi = true;
    },
    async getBatch() {
      let params = new URLSearchParams();

      params.set('id_status_saldo', this.statusTab + 1);
      // params.set('id_mst_order_type', 2);
      // if (this.searchNomorPesanan != '') {
      //   params.set('no_order', this.searchNomorPesanan);
      // }
      // if (this.isKonfirmasi) {
      //   params.set('id_mst_pembayaran_status', 1);
      // } else {
      //   params.set('id_mst_pembayaran_status', 2);
      // }
      // var offset = (this.offset = (this.page - 1) * this.limit);
      // params.append('offset', offset);
      // params.append('limit', this.limit);

      var request = {
        params: params,
        headers: { Authorization: 'Bearer ' + this.users.token }
      };
      await this.$req
        .get(this.$root.$baseapi.transaksi + '/transaksi/v4/saldo_biz', request)
        .then(response => {
          let { data } = response.data;
          this.listBatch = data == null ? [] : data;
          this.pickBatch = '';
          this.listBatchUser = [];
          this.pickBatchUser = null;
          for (let i = 0; i < this.listBatch.length; i++) {
            this.listBatch[i].tanggal = this.listBatch[i].tanggal.substring(
              0,
              10
            );
          }
          if (this.$route.query.batch) {
            this.pickBatch = this.$route.query.batch;
            this.getBatchUser();
          } else {
            for (let i = 0; i < this.listBatch.length; i++) {
              this.pickBatch = this.listBatch[i].tanggal;
              this.getBatchUser();
              break;
            }
          }
          // this.listRefundTiket = data == null ? [] : data;
          // var mod = response.data.count % this.limit;
          // var lengthPage = 0;

          // lengthPage = (response.data.count - mod) / this.limit;

          // if (mod == 0) {
          //   this.lengthPage = lengthPage;
          // } else {
          //   this.lengthPage = lengthPage + 1;
          // }
          console.log('listBatch', this.listBatch);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getBatchUser() {
      let params = new URLSearchParams();

      if (this.searchUser) {
        params.set('search', this.searchUser);
      }

      params.set('id_status_saldo', this.statusTab + 1);
      params.set('date', this.pickBatch);
      // params.set('id_mst_order_type', 2);
      // if (this.searchNomorPesanan != '') {
      //   params.set('no_order', this.searchNomorPesanan);
      // }
      // if (this.isKonfirmasi) {
      //   params.set('id_mst_pembayaran_status', 1);
      // } else {
      //   params.set('id_mst_pembayaran_status', 2);
      // }
      // var offset = (this.offset = (this.page - 1) * this.limit);
      // params.append('offset', offset);
      // params.append('limit', this.limit);

      var request = {
        params: params,
        headers: { Authorization: 'Bearer ' + this.users.token }
      };
      await this.$req
        .get(this.$root.$baseapi.transaksi + '/transaksi/v4/saldo_biz', request)
        .then(response => {
          let { data } = response.data;
          this.listBatchUser = data == null ? [] : data;
          this.pickBatchUser = null;
          if (this.$route.query.id) {
            for (let i = 0; i < this.listBatchUser.length; i++) {
              if (this.listBatchUser[i].id_pencairan == this.$route.query.id) {
                this.pickBatchUser = this.listBatchUser[i];
                this.getUser(this.pickBatchUser.id);
                break;
              }
            }
          } else {
            for (let i = 0; i < this.listBatchUser.length; i++) {
              this.pickBatchUser = this.listBatchUser[i];
              this.getUser(this.pickBatchUser.id);
              break;
            }
          }
          // for (let i = 0; i < this.listBatch.length; i++) {
          //   this.pickBatch = this.listBatch[i].tanggal
          //   this.getBatchUser()
          // }
          // this.listRefundTiket = data == null ? [] : data;
          // var mod = response.data.count % this.limit;
          // var lengthPage = 0;

          // lengthPage = (response.data.count - mod) / this.limit;

          // if (mod == 0) {
          //   this.lengthPage = lengthPage;
          // } else {
          //   this.lengthPage = lengthPage + 1;
          // }
          console.log('listBatchUser', this.listBatchUser);
          console.log('pickBatchUser', this.pickBatchUser);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async postProsesPencairan() {
      let formData = new FormData();

      formData.set('id', this.pickBatchUser.id_pencairan);

      await this.$req
        .post(
          this.$root.$baseapi.transaksi + '/transaksi/v4/proses_pencairan',
          formData,
          {
            headers: { Authorization: 'Bearer ' + this.users.token }
          }
        )
        .then(response => {
          this.dialogKonfirmasi = false;
          // this.getBatch();
          this.goToBatch(this.pickBatch, this.pickBatchUser.id_pencairan, 1);
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    async postBatalProses() {
      let formData = new FormData();

      formData.set('id', this.pickBatchUser.id_pencairan);
      formData.set('alasan', this.alasanTolak);

      await this.$req
        .post(
          this.$root.$baseapi.transaksi + '/transaksi/v4/tolak_proses',
          formData,
          {
            headers: { Authorization: 'Bearer ' + this.users.token }
          }
        )
        .then(response => {
          this.dialogAlasanTolak = false;
          this.alasanTolak = '';
          this.clearBukti();
          this.goToBatch(this.pickBatch, this.pickBatchUser.id_pencairan, 0);
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    async postPencairanSaldo() {
      let formData = new FormData();

      formData.set('id', this.pickBatchUser.id_pencairan);
      formData.set('foto', this.buktiBayar.buktiCompressed);

      await this.$req
        .post(
          this.$root.$baseapi.transaksi + '/transaksi/v4/pencairan_saldo',
          formData,
          {
            headers: { Authorization: 'Bearer ' + this.users.token }
          }
        )
        .then(response => {
          this.dialogKonfirmasi = false;
          this.clearBukti();
          this.goToBatch(this.pickBatch, this.pickBatchUser.id_pencairan, 2);
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    clearBukti() {
      this.buktiBayar = {
        bukti: null,
        gambarBuktiPembayaran: null,
        namaBuktiPembayaran: '',
        buktiCompressed: null
      };
      this.loadValue = 0;
    },
    onFileChange() {
      this.buktiBayar.gambarBuktiPembayaran = URL.createObjectURL(
        this.buktiBayar.bukti
      );
      this.buktiBayar.namaBuktiPembayaran = this.buktiBayar.bukti.name;

      // console.log('gambarBuktiPembayaran', this.gambarBuktiPembayaran)
      // console.log('namaBuktiPembayaran', this.namaBuktiPembayaran)
      // this.compressImage()
      this.handleImageUpload();
      this.startProgressUpload();
    },
    startProgressUpload() {
      this.loadValue = 0;
      this.progressLoad = setInterval(() => {
        if (this.loadValue < 100) {
          this.loadValue = this.loadValue + 5;
        } else {
          clearInterval(this.progressLoad);
        }
      }, 100);
    },
    async handleImageUpload() {
      const imageFile = this.buktiBayar.bukti;
      // console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
      // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true
      };
      try {
        const compressedFile = await imageCompression(imageFile, options);
        // this.buktiBayarCompress = compressedFile
        this.buktiBayar.buktiCompressed = this.blobToFile(
          compressedFile,
          this.buktiBayar.namaBuktiPembayaran
        );
        console.log('bukti bayuar', this.buktiBayar);
        // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
        // console.log('hasil comp', compressedFile)
        // await uploadToServer(compressedFile); // write your own logic
      } catch (error) {
        console.log(error);
      }
    },
    blobToFile(theBlob, fileName) {
      return new File([theBlob], fileName, {
        lastModified: new Date().getTime(),
        type: theBlob.type
      });
    },
    async goToBatch(pickBatch, idPencairan, status) {
      this.$router.push(
        '/pencairan_saldo?batch=' + pickBatch + '&id=' + idPencairan
      );
      this.statusTab = status;
      await this.getBatch();
      // await this.getBatchUser();
      // for (let i = 0; i < this.listBatchUser.length; i++) {
      //   if (this.listBatchUser[i].id_pencairan == idPencairan) {
      //     this.pickBatchUser = this.listBatchUser[i];
      //     break;
      //   }
      // }
    },
    async getUser(id) {
      this.dataUser = null;
      await this.$req
        .get(this.$root.$baseapi.user + '/user/v3/user', {
          params: {
            id: id,
            limit: 1
          },
          headers: { Authorization: 'Bearer ' + this.users.token }
        })
        .then(response => {
          let { data } = response.data;
          this.dataUser = data == null || data == [] ? null : data[0];
          console.log('data user', this.dataUser);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    }
  },
  created() {
    if (this.$route.query.batch) {
      this.$router.push('/pencairan_saldo');
    }
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);
    this.getBatch();
    // this.infoAction = {
    //   snackbar: true,
    //   message: 'adad',
    //   color: 'success'
    // };
  }
};
</script>

<style></style>
